'use client'

import { memo, type ReactNode } from 'react'
import '../craft.css'
import { CRAFT_MEDIA } from './craft-media'
import { CraftFooter } from './craft-footer'
import { CraftNav } from './craft-nav'

type CraftShellProps = {
  children: ReactNode
  /** baby: Optional in-page scroll handler (landing only). */
  onScrollTo?: (id: string) => void
}

/**
 * baby: Shared kraft shell for craft landing + enterprise/banks/govts pages.
 */
export const CraftShell = memo(function CraftShell({ children, onScrollTo }: CraftShellProps) {
  return (
    // baby: ninxl-8bit class keeps theme CSS tokens; craft.css overrides the pixel HUD.
    <div className="ninxl-craft ninxl-landing ninxl-8bit" data-ninxl-theme="light">
      <video
        className="ninxl-craft__atmosphere"
        src={CRAFT_MEDIA.atmosphereVideo}
        muted
        playsInline
        autoPlay
        loop
        preload="none"
        aria-hidden
      />
      <div className="ninxl-craft__edge" aria-hidden />
      <div className="ninxl-craft__grain" aria-hidden />

      <div className="ninxl-craft__content">
        <CraftNav onScrollTo={onScrollTo} />
        {children}
        <CraftFooter />
      </div>
    </div>
  )
})

CraftShell.displayName = 'CraftShell'
